import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-57121164"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "alerts-list"
};
const _hoisted_2 = {
  class: "alerts-list-category-top"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "alerts-list-category-title"
};
const _hoisted_5 = {
  class: "alerts-list-category-number"
};
const _hoisted_6 = {
  class: "alerts-list-category-name"
};
const _hoisted_7 = {
  class: "alerts-list-items"
};
const _hoisted_8 = {
  class: "alerts-list-items-inner"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "alerts-list-item-image"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "alerts-list-item-flag"
};
const _hoisted_14 = ["src", "alt"];
const _hoisted_15 = {
  class: "alerts-list-item-title-box"
};
const _hoisted_16 = {
  class: "alerts-list-item-title"
};
const _hoisted_17 = {
  class: "alerts-list-item-description-box"
};
const _hoisted_18 = {
  class: "alerts-list-item-description"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "alerts-list-item-status"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "alerts-list-items-line"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_alerts_status = _resolveComponent("alerts-status");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredItems, category => {
    return _openBlock(), _createElementBlock("div", {
      key: category.id,
      class: _normalizeClass(['alerts-list-category', {
        open: $data.openCategories.includes(category.id)
      }])
    }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
      class: "alerts-list-category-button",
      onClick: $event => $options.onToggleOpen(category.id)
    }, [_createVNode(_component_app_icon, {
      icon: "chevron-down2",
      size: 20,
      color: "#757575"
    })], 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(category.items.length), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(category.name), 1)])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.items, item => {
      return _openBlock(), _createElementBlock("div", {
        key: item.id,
        class: _normalizeClass(['alerts-list-item', {
          active: $props.selectedId == item.id
        }]),
        onClick: _withModifiers($event => $options.onToggleId(item.id), ["self"])
      }, [_createElementVNode("div", {
        class: "alerts-list-item-left",
        onClick: $event => $options.onToggleId(item.id)
      }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
        src: item.main_image_link,
        alt: ""
      }, null, 8, _hoisted_12)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
        src: _ctx.getCountryFlag(item.country_code),
        alt: item.country_code
      }, null, 8, _hoisted_14)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(item.seller_name) + " - " + _toDisplayString(item.product_title_amazon), 1)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(item.alerting_message), 1)])], 8, _hoisted_10), _createElementVNode("div", {
        class: "alerts-list-item-right",
        onClick: _withModifiers($event => $options.onToggleId(item.id), ["self"])
      }, [_createElementVNode("div", {
        class: "alerts-list-item-avatar",
        style: _normalizeStyle($props.selectedId == item.id ? {
          color: item.assignee.color,
          backgroundColor: item.assignee.back,
          border: 0
        } : null),
        onClick: $event => $options.onToggleId(item.id)
      }, _toDisplayString(item.assignee.name[0]), 13, _hoisted_20), _createElementVNode("div", {
        class: "alerts-list-item-date",
        onClick: $event => $options.onToggleId(item.id)
      }, _toDisplayString($options.createdAt(item.created_at)), 9, _hoisted_21), _createElementVNode("div", _hoisted_22, [_createVNode(_component_alerts_status, {
        modelValue: item.status,
        "onUpdate:modelValue": $event => item.status = $event,
        disabled: true
      }, null, 8, ["modelValue", "onUpdate:modelValue"])])], 8, _hoisted_19)], 10, _hoisted_9);
    }), 128))]), _hoisted_23])], 2);
  }), 128))]);
}